import { applyMiddleware } from "redux";

const storage = (store) => (next) => (action) => {
  next(action);
  const data = store.getState();
  if (data.teacher) {
    localStorage.setItem("teacher", JSON.stringify(data.teacher));
  } else {
    localStorage.removeItem("teacher");
  }

  localStorage.setItem("theme", data.theme);
};

const middleware = applyMiddleware(storage);

export default middleware;
